import { getCategoryId } from '@/composables/utils'
import { calcCategoryGoalRatingAvg } from './calcCategoryGoalRatingAvg'
import { store } from '@/store'

const isOtherSubCategory = (subCategoryId) => {
  const subCategory = store.getters['sub-categories/get'](subCategoryId)
  return subCategory?.isRequired === true
}

/**
 * Get the average rating for a category in a goal collection
 * This is used to display ratings and visualizations for a goal collection
 * this it NOT used for calculating the average rating for a category in a compass
 */
export const getCategoryGoalCollectionRatingAvg = (categoryId, goalCollectionId) => {
  const query = {
    goalCollectionId,
  }
  const goalsResponse = store.getters['goal-collections-sub-categories/find']({ query })
  const goals = goalsResponse.data
  const relevantGoals = goals
    .filter(goal => (
      getCategoryId(goal.subCategoryId) === categoryId &&
      !isOtherSubCategory(goal.subCategoryId) &&
      goal.isEnabled === true
    ))
  console.log('!! relevantGoals', relevantGoals)
  return Math.round(calcCategoryGoalRatingAvg(relevantGoals.map(goal => goal.rating)))
}
